import { render, staticRenderFns } from "./FitPreview.vue?vue&type=template&id=6788e294&scoped=true"
import script from "./FitPreview.vue?vue&type=script&lang=js"
export * from "./FitPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6788e294",
  null
  
)

export default component.exports